import React from 'react'

import styles from './styles.module.scss'

const ButtonCarousel = ({ onClick, className = '' }) => {
    return (
        <button className={`button ${styles['button-carousel']} ${className}`} onClick={onClick}>
            <div className={styles['button-carousel__inner']}>
                <svg className={styles['button-carousel__icon']} xmlns="http://www.w3.org/2000/svg" width="8.817" height="13.392" viewBox="0 0 8.817 13.392">
                    <path d="M0,5.635,5.636,0l5.635,5.635" transform="translate(6.696 1.061) rotate(90)" fill="none" stroke="#fff" strokeWidth="3"/>
                </svg>
            </div>
        </button>
    )
}

export default ButtonCarousel
